export default "__VITE_ASSET__O0DzOfdI__"